import { Component, effect, signal, untracked, inject } from '@angular/core';
import { ReservationTrajetDto } from '../../../../../shared/dto/reservation-trajet.dto';
import { TrajetSelectionneService } from '../../services/trajet-selectionne.service';
import { TrajetService } from '../../../../../shared/services/trajet.service';
import { finalize } from 'rxjs/operators';
import { ApplicationErreur, AlertService, isNullOrUndefined } from 'sigale-angular';

@Component({
	selector: 'app-liste-reservations',
	templateUrl: './liste-reservations.component.html',
	styleUrl: './liste-reservations.component.scss'
})
export class ListeReservationsComponent {
	// Constantes
	readonly NOM_ALERTE_TRAJETS = "alerteTabTrajets";

	// Injections
	private alertService = inject(AlertService);
	private trajetSelectionneService = inject(TrajetSelectionneService);
	private trajetService = inject(TrajetService);

	// Signaux
	enChargement = signal<boolean>(false);
	panelReservationsOuvert = signal<boolean>(false);
	reservations = signal<ReservationTrajetDto[]>([]);

	// Variables
	trajetId: number | null = null;

	constructor() {
		this.ecouterChangementTrajetSelectionne();
	}

	/**
	 * Écoute les changements du trajet sélectionné, récupère les réservations du trajet et ferme le panel si le trajet a changé.
	 */
	ecouterChangementTrajetSelectionne(): void {
		effect(() => {
			const id = this.trajetSelectionneService.trajetSelectionne()?.id ?? null;
			if (id !== this.trajetId) {
				this.trajetId = id;
				this.panelReservationsOuvert.set(false);
			}
			this.recupererReservations();
		}, { allowSignalWrites: true });
	}

	/**
	 * Récupère les réservations du trajet sélectionné.
	 */
	recupererReservations(): void {
		if (isNullOrUndefined(this.trajetId)) {
			return;
		}
		this.enChargement.set(true);
		this.alertService.clear(this.NOM_ALERTE_TRAJETS);

		this.trajetService.recupererReservationsTrajet(this.trajetId).pipe(
			finalize(() => {
				this.enChargement.set(false);
			})
		).subscribe({
			next: (reservations: ReservationTrajetDto[]) => {
				reservations.sort((a: ReservationTrajetDto, b: ReservationTrajetDto) => new Date(a.dateReservation).getTime() - new Date(b.dateReservation).getTime());
				this.reservations.set(reservations);
			},
			error: (erreur) => {
				this.alertService.error(erreur.error, this.NOM_ALERTE_TRAJETS);
			}
		});
	}
}
